import type { Transition } from "@uirouter/core";

import { proNavigator } from "single-spa/react-app/ProNavigator";
import type { IRouterState } from "single-spa/react-app/router/IRouterState";

export const onEnterRemoveComparedDuration = (transition: Transition): void => {
    const toState = transition.to() as IRouterState;
    const params = transition.params();
    const hasComparedDuration =
        params.comparedDuration !== null &&
        params.comparedDuration !== undefined &&
        params.comparedDuration !== "";

    if (!toState.periodOverPeriodEnabled && hasComparedDuration) {
        void proNavigator.go(toState.name, { ...params, comparedDuration: null }, { location: "replace" });
    }
};
